module.exports = __webpack_public_path__ + "models/snapshot.bcb9e76.txt";